import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Angulartics2Module } from 'angulartics2';

import {
  ConfirmationModule,
  FormValidationModule,
} from '@tablesready/common-ui';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthComponent } from './auth.component';
import { COMPONENTS } from './components';
import { SERVICES } from './services';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { IonicModule } from '@ionic/angular';
import { StatusModule } from '@tablesready/frontend-status-bar';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';
import { SignupByInviteModule } from '../signup-by-invite/signup-by-invite.module';

@NgModule({
  declarations: [AuthComponent, ...COMPONENTS],
  imports: [
    FrontendIconsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormValidationModule,
    ConfirmationModule,
    AuthRoutingModule,
    Angulartics2Module,
    IonicModule,
    StatusModule,
    AlertsModule,
    SignupByInviteModule,
  ],
  providers: SERVICES,
})
export class AuthModule {
}
